import { State } from "../../types";
import { GetCanvasBlockOrder, GetCanvasBlocks } from "./paginate";

export type SetPageSizeAction = Readonly<{
  pageSize: number;
  numImages: number;
  type: "SET PAGE SIZE";
}>;

export const setPageSize = (state: State, action: SetPageSizeAction): State => {
  const activeBlockOrder = GetCanvasBlockOrder(state, state.currentPage * action.pageSize, (state.currentPage+1) * action.pageSize);
  const activeBlocks = GetCanvasBlocks(state, state.currentPage * action.pageSize, (state.currentPage+1) * action.pageSize);

  // this is a rudimentary adjustment that prevents currentPage from overflowing
  // when the page size increases.
  // TODO : this can be improved to try and not move the context too much in either
  // direction (wishlist)
  let newCurrentPage = state.currentPage;
  while (action.pageSize * (newCurrentPage + 1) > action.numImages) {
    newCurrentPage -= 1
  } 
  return {
    ...state,
    pageSize: action.pageSize,
    currentPage: newCurrentPage,
    activeBlockOrder,
    activeBlocks,
  };
};

